import { Dashboard } from 'api/dashboard';

const getFromLocalStorage = (): number =>
  Number(localStorage.getItem('preferredDashboard') || '-1');

const predicateById = (d: Dashboard): boolean =>
  d.dashboardId === getFromLocalStorage();

export const lastVisitedDashboardActions = {
  update: (id: number): void => {
    if (localStorage.getItem('preferredDashboard') === `${id}`) {
      return;
    }
    localStorage.setItem('preferredDashboard', `${id}`);
  },
  getOnlyActive: (activeDashboards: Dashboard[]): number | undefined =>
    activeDashboards.find(predicateById)?.dashboardId,
};
